import slice from './cart.slice';
export {
    fetchCartById,
    setCustomer,
    setBillingInfo,
    fetchLightCartById,
    setFingerprint,
} from './cart.slice';
export default slice.reducer;
